import { createColumnRows, transformWHInStyle, createColVnode } from './utils'
import { HEADER_HEIGHT } from '../../utils'
import { createHeaderThead } from './header-thead'
import { createHeaderBody } from './header-tbody'
import { mapStates } from '../../store'
import { BORDER_VALUE, MAIN_TABLE } from '../../config'
import '../../style/header.scss'
import '../../style/virtual-grid.scss'

const HeaderThead = createHeaderThead()
const HeaderTBody = createHeaderBody()

export function createHeader() {
  return {
    name: 'virtual-table-header',
    props: {
      store: Object,
      rowColumns: {
        type: Array,
        default: () => []
      },
      headerColumns: {
        type: Array,
        default: () => []
      },
      headerHeight: {
        type: Number,
        default: HEADER_HEIGHT
      },
      range: Object,
      width: Number,
      headerAlign: String,
      rowHeight: Number,
      rowsLength: Number,
      border: Boolean,
      type: String,
      handleEvent: Function,
    },
    data () {
      return {
        headerPopoverAttrs: {},
        createPopperElm: () => null
      }
    },
    computed: {
      ...mapStates({
        maxLevel: 'maxLevel',
      }),
      isMainTable () {
        return this.$props.type === MAIN_TABLE
      },
      headerColumnRows() {
        const { headerHeight, headerColumns } = this.$props
        return createColumnRows(headerColumns, headerHeight, this.maxLevel, this.store.states.collapsedMap)
      },
    },
    render() {
      const { $props } = this
      const [slots] = this.$slots.default || []
      const isMainTable = this.isMainTable
      const width = isMainTable ? $props.width - BORDER_VALUE : $props.width
      const { header: headerSlots, row: rowSlots, ...resetSlots } = slots
      const { headerColumns } = $props
      const { horizontalVirtualRange } = this.store.states
      const { padFront } = horizontalVirtualRange
      const colVnode = createColVnode(this.$createElement, headerColumns)
      const headerTableStyle = transformWHInStyle({ width })
      const hasFixedRows = !!$props.rowsLength
      const headerWrapClass = ['kye-table-v2-header-wrapper', hasFixedRows ? 'kye-table-v2-header-wrapper-fixed-rows' : '']
      const { visibleFlatColumns } = this.store.states
      const wrapStyle = {
        width: (isMainTable ? visibleFlatColumns.reduce((acc, col) => {
          if (!col.children || !col.children.length) { acc += col.width }
          return acc
        }, 0) : width) + 'px',
        position: 'relative',
      }
      const style = {
        transform: `translateX(${isMainTable ? padFront : 0}px)`,
        position: 'relative',
        // position: 'absolute',
      }
      const headerPopoverAttrs = {
        ...this.headerPopoverAttrs,
        ref: 'headerPopoverRef',
      }
      return (
        <div
          class={headerWrapClass}
          style={headerTableStyle}
          ref="headerContainer"
        >
          <div style={wrapStyle}>
            <div style={style}>
              <table
                class="virtual-grid__inner__table"
              >
                <colgroup>
                  {
                    colVnode
                  }
                </colgroup>
                {
                  headerSlots || (
                    <HeaderThead
                      headerColumnRows={this.headerColumnRows}
                      headerAlign={this.headerAlign}
                      defaultSort={this.defaultSort}
                      store={this.store}
                      handleEvent={$props.handleEvent}
                      type={$props.type}
                      setHeaderPopoverAttrs={this.setHeaderPopoverAttrs}
                      changeHeaderPopoverVisibleStatus={this.changeHeaderPopoverVisibleStatus}
                      getHeaderPopoverAttrs={this.getHeaderPopoverAttrs}
                    >
                      {
                        resetSlots
                      }
                    </HeaderThead>
                  )
                }
                {
                  hasFixedRows ? (<HeaderTBody
                    rowsLength={$props.rowsLength}
                    columns={this.rowColumns}
                    rowHeight={$props.rowHeight}
                    loadingRow={$props.loadingRow}
                  >
                    {{ default: rowSlots }}
                  </HeaderTBody>) : null
                }
              </table>
            </div>
          </div>
          <el-popover data-type={this.$props.type + '_head-pop'} class="table2-head-pop" {...headerPopoverAttrs}>
            {
              this.createPopperElm()
            }
          </el-popover>
        </div>
      )
    },
    methods: {
      scrollToLeft(left) {
        if (this.$refs.headerContainer && this.$refs.headerContainer.scrollLeft !== left) {
          this.$nextTick(() => {
            this.$refs.headerContainer.scrollLeft = left
          })
        }
      },
      // 设置气泡组件组件属性与内容
      setHeaderPopoverAttrs (attrs, createPopperElm) {
        if (!attrs) {
          console.info('setHeaderPopoverAttrs：缺少气泡属性')
          return
        }
        if (!attrs || !attrs.props) {
          console.info('setHeaderPopoverAttrs：缺少气泡props属性')
          return
        }
        if (!attrs || !attrs.props.reference) {
          console.info('setHeaderPopoverAttrs：缺少reference属性')
          return
        }
        if (!createPopperElm) {
          console.info('setHeaderPopoverAttrs：缺少气泡内容函数')
          return
        }
        this.headerPopoverAttrs = attrs
        this.$refs.headerPopoverRef.referenceElm = attrs.props.reference
        this.createPopperElm = createPopperElm
        // 重新计算气泡
        this.$refs.headerPopoverRef.createPopper()
      },
      // 气泡显示状态调整
      changeHeaderPopoverVisibleStatus (visible = null) {
        this.$refs.headerPopoverRef.showPopper = visible !== null ? visible : !this.$refs.headerPopoverRef.showPopper
        this.hiddenOtherHeaderPopover()
      },
      hiddenHeaderPopover () {
        this.changeHeaderPopoverVisibleStatus(false)
      },
      hiddenOtherHeaderPopover () {
        const self = this.$el.querySelector('.table2-head-pop')
        const selfShowPopper = self && self.__vue__ && self.__vue__.showPopper
        const otherPop = this.$props.store.table.$el.querySelectorAll('.table2-head-pop')
        Array.from(otherPop).forEach(el => {
          const isSelf = el === self
          if (!isSelf) {
            try {
              if (selfShowPopper) {
                el.__vue__.showPopper = false
              }
            } catch (error) {
              console.error('【kye-table2】', 'filterClick')
            }
          }
        })
      },
      getHeaderPopoverAttrs () {
        return this.headerPopoverAttrs
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/header/index.js